/** Shared helpers for request-tracker polling. */

export function isRequestTrackingStatusActive(status: string): boolean {
  return status === 'queued' || status === 'running';
}

/** Run an interval callback only when the tab is visible. */
export function runIfDocumentVisible(fn: () => void): void {
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
    return;
  }
  fn();
}
